import { render, staticRenderFns } from "./reclaim-card.vue?vue&type=template&id=784737b3&scoped=true&"
import script from "./reclaim-card.vue?vue&type=script&lang=js&"
export * from "./reclaim-card.vue?vue&type=script&lang=js&"
import style0 from "./reclaim-card.vue?vue&type=style&index=0&id=784737b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784737b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VFlex,VIcon,VLayout,VProgressLinear,VTooltip})
